module.exports = __webpack_public_path__ + "img/softfare.e56aaf73.jpeg";